// Values mirror the public.tariff_category and public.tariff_commodity enums (onward-hasura
// migration tariff_categorization). Array order is display order.

// Section key for tariffs with no category (category is NULL in the database).
export const UNTAGGED = 'UNTAGGED';
export const UNTAGGED_LABEL = 'Untagged';

export const TARIFF_CATEGORIES = [
    { value: 'FINAL_MILE_SHIPPER', label: 'Final Mile Shipper' },
    { value: 'MIDDLE_MILE_SHIPPER', label: 'Middle Mile Shipper' },
    { value: 'WAREHOUSE_SHIPPER', label: 'Warehouse Shipper' },
    { value: 'FINAL_MILE_CARRIER', label: 'Final Mile Carrier' },
    { value: 'MIDDLE_MILE_CARRIER', label: 'Middle Mile Carrier' },
    { value: 'WAREHOUSE_CARRIER', label: 'Warehouse Carrier' },
    { value: 'CONTRACTOR_CARRIER', label: 'Contractor Carrier' },
];

// The group tabs. Each lists the sections it shows, in order; only All includes Untagged.
export const DEFAULT_GROUP = 'ALL';
export const TARIFF_CATEGORY_GROUPS = [
    { value: DEFAULT_GROUP, label: 'All', categories: [...TARIFF_CATEGORIES.map((c) => c.value), UNTAGGED] },
    {
        value: 'SHIPPERS',
        label: 'Shippers',
        categories: ['FINAL_MILE_SHIPPER', 'MIDDLE_MILE_SHIPPER', 'WAREHOUSE_SHIPPER'],
    },
    {
        value: 'CARRIERS',
        label: 'Carriers',
        categories: ['FINAL_MILE_CARRIER', 'MIDDLE_MILE_CARRIER', 'WAREHOUSE_CARRIER', 'CONTRACTOR_CARRIER'],
    },
];

export const ALL_COMMODITIES = 'ALL_COMMODITIES';
export const TARIFF_COMMODITIES = [
    { value: 'FURNITURE', label: 'Furniture' },
    { value: 'MATTRESSES', label: 'Mattresses' },
    { value: 'APPLIANCES', label: 'Appliances' },
    { value: 'EXERCISE_EQUIPMENT', label: 'Exercise Equipment' },
    { value: 'PALLETS', label: 'Pallets' },
    { value: 'CABINETS', label: 'Cabinets' },
    { value: 'BUILDING_MATERIALS', label: 'Building Materials' },
    { value: ALL_COMMODITIES, label: 'All Commodities' },
];

// Account roles (users.roles keys) for the "Assigned to" pills, in display order. The carrier
// sub-roles usually sit alongside CARRIER, but an account holding only one still reads Carrier.
export const ACCOUNT_ROLES = [
    { label: 'Shipper', keys: ['SHIPPER'] },
    { label: 'Carrier', keys: ['CARRIER', 'MIDDLE_MILE_CARRIER', 'WH_CARRIER', 'WAREHOUSE_CARRIER'] },
    { label: 'Contractor', keys: ['CONTRACTOR'] },
];
export const OTHER_ACCOUNT_LABEL = 'Account';

// Platform-wide default overrides have no account; their algo_type says which side they price.
export const PLATFORM_LABEL = 'Platform';
export const PLATFORM_DEFAULTS = {
    SHIPPER_GLOBAL_DEFAULT: 'All shippers',
    CARRIER_GLOBAL_DEFAULT: 'All carriers',
};
